import { useMemo } from 'react'
import { AdminTable, type Column } from './AdminTable'
import { Pagination } from './Pagination'
import { DeleteButton } from './DeleteButton'
import { LoadingBar } from './LoadingBar'
import { useAdminTab } from '@/hooks/useAdminTab'
import { fetchAdminReadings, deleteAdminReading } from '@/api/admin'
import type { AdminReading } from '@/types/admin'
import { CefrBadge } from '@/components/ui/CefrBadge'

interface ReadingsTabProps {
  active: boolean
}

export function ReadingsTab({ active }: ReadingsTabProps) {
  const { data, meta, loading, setPage, refresh } = useAdminTab(fetchAdminReadings, active)

  const columns: Column<AdminReading>[] = useMemo(
    () => [
      { key: 'title', label: 'Title', render: (r) => r.title },
      { key: 'language', label: 'Language', render: (r) => r.language_name },
      {
        key: 'difficulty',
        label: 'Difficulty',
        render: (r) => <CefrBadge level={r.difficulty_level} />,
      },
      { key: 'author', label: 'Author', render: (r) => r.author_email },
      { key: 'created', label: 'Created', render: (r) => new Date(r.created_at).toLocaleDateString() },
      {
        key: 'actions',
        label: '',
        render: (r) => (
          <DeleteButton
            label={`Delete reading ${r.title}`}
            onDelete={() => deleteAdminReading(r.id)}
            onSuccess={refresh}
          />
        ),
        className: 'w-10',
      },
    ],
    [refresh],
  )

  if (!active) return null

  return (
    <div>
      {loading && <div className="mb-4"><LoadingBar /></div>}
      <AdminTable columns={columns} data={data} keyFn={(r) => r.id} />
      <Pagination meta={meta} onPageChange={setPage} />
    </div>
  )
}
